import qs from 'query-string';
import { useEffect } from 'react';

import { getDefaultManageSearchInfo, processSearchInfo } from '@exchange-frontends/utils';

/**
 * Get the search information depending on the page
 * @param {string} pageName // for identifying the page
 */
const getPageSearchInformation = (pageName) => {
  if (pageName === 'Exchange:Manage') {
    return getDefaultManageSearchInfo();
  }
  return qs.parse(window.location.search);
};

/**
 * Capturing the impression (page views)
 * @param {Object} page // for identifying the page
 * @param {boolean} [isLoaded] // for checking if the page is loaded first
 * @param {?string|number} [totalSearchResults] // for the total search results
 */
const useAnalyticsPageLoad = (page, isLoaded = true, totalSearchResults) => {
  useEffect(() => {
    if (isLoaded) {
      const searchInfo = getPageSearchInformation(page.pageName);
      const siteSearch = processSearchInfo(searchInfo, totalSearchResults);

      window?._satellite?.track('state', {
        xdm: {},
        data: {
          web: {
            webPageDetails: {
              name: page.pageName,
              siteSection: page.siteSection,
            },
          },
          siteSearch,
        },
      });
    }
  }, [page, isLoaded]);
};

export default useAnalyticsPageLoad;
